<script>
  import { createEventDispatcher } from 'svelte'
  import { onMount } from 'svelte'
  const dispatch = createEventDispatcher()

  const userPrefLangs = navigator.languages || ['en']
  console.log(userPrefLangs)

  let languages = [
    { id: 'en', text: `English` },
    { id: 'es', text: `Spanish` },
    { id: 'de', text: `German` },
    { id: 'fr', text: `French` },
    { id: 'sv', text: `Swedish` },
    { id: 'ma', text: `Moroccan` },
  ]

  let allowedCounts = [1, 5, 10, 20, 50, 100]

  const defaultUserLang = userPrefLangs.find((userLang) => languages.find((suppLang) => userLang === suppLang.id))

  $: language = defaultUserLang
  $: count = 20
  $: index = 0
  let refresh = 1

  function triggerRefresh() {
    console.log('triggerRefresh', refresh)
    dispatch('menuChanges', {
      reload: 'true',
      language,
      count,
      index,
    })
  }

  onMount(async () => {
    triggerRefresh()
  })
</script>

<form on:submit|preventDefault>
  <div class="selections-header-container">
    <div>
      <a href="/"><img src="../img/infinity.svg" class="logo" alt="logo" /></a>
    </div>
    <div style="display: none">
      Specific index: <input type="text" bind:value={index} />
    </div>
    <div>
      <!-- svelte-ignore a11y-no-onchange -->
      <select bind:value={language} on:change={triggerRefresh}>
        {#each languages as lang}
          <option value={lang.id}>
            {lang.text}
          </option>
        {/each}
      </select>
    </div>
    <div>
      <!-- svelte-ignore a11y-no-onchange -->
      <select bind:value={count} on:change={triggerRefresh}>
        {#each allowedCounts as val}
          <option selected={val == count} value={val}>
            {val}
          </option>
        {/each}
      </select>
    </div>
    <div class="refresh" on:click={triggerRefresh} >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path d="M10 3v2a5 5 0 00-3.54 8.54l-1.41 1.41A7 7 0 0110 3zm4.95 2.05A7 7 0 0110 17v-2a5 5 0 003.54-8.54l1.41-1.41zM10 20l-4-4 4-4v8zm0-12V0l4 4-4 4z"/>
      </svg>
    </div>

    <div class="about">
      <a href="/wordgen/about">
        <svg  class="svgfix" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zM9 11v4h2V9H9v2zm0-6v2h2V5H9z" />
        </svg>
      </a>
    </div>
  </div>
</form>

<style>
  .selections-header-container {
    padding: 6px;
    display: flex;
    align-items: stretch;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    background-color: rgba(6, 79, 148, 0.8);
    min-height: 50px;
    margin-bottom: 5px;
  }
  .selections-header-container > div {
    background-color: rgba(255, 192, 203, 0);
    text-align: center;
  }

  .logo {
    width: 50px;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; /* Remove default arrow */
    background-image: url(/img/cheveron-outline-down.svg);
    background-size: 25px;
    background-repeat: no-repeat;
    background-position: bottom 8px right 7px;
    font-size: 1.2em;
    border-radius: 5px;
    padding: 10px;
    padding-right: 30px;
  }
  .about {
    font-size: 1.2em;
    width: 30px;
  }

  .svgfix {
    fill: rgb(221, 221, 221);
  }

  .refresh {
    width:35px;
    fill: rgb(221, 221, 221);
    stroke:rgba(221, 221, 221, 0.3);
  }

</style>
